<!--  it's only for sort-header, no table-body  -->

<!--  to add sort-header  -->
<div
  [class.hidden]="!dataSource?.data?.length"
  class="table-sort-header"
>
  <table
    [dataSource]="dataSource"
    [matSortActive]="sortState.column"
    [matSortDirection]="sortState.direction"
    [hidden]="!dataSource?.data?.length"
    (matSortChange)="onSortChange($event)"
    class="table-sort-header"
    mat-table
    matSort
  >
    @for (column of allDisplayedColumns; track column) {
      <ng-container [matColumnDef]="column">
        <th
          [ngClass]="column"
          *matHeaderCellDef
          class="table-sort-header-cell"
          mat-header-cell
          mat-sort-header
          disableClear
        >
          {{ basicSortHeaderTitles[column] ?? sortHeaderTitles[column] ?? column }}
        </th>
        <mat-cell
          *matCellDef="let element; let i = index"
          mat-cell
        ></mat-cell>
      </ng-container>
    }
    <tr
      *matHeaderRowDef="allDisplayedColumns"
      mat-header-row
      class="table-header-row"
    ></tr>
  </table>
</div>

<!-- headerHeight shouldn`t be defined as 0, because it fallback to default 56px height, that causes calculation issues -->
<cdk-virtual-scroll-viewport
  [tvsItemSize]="ITEM_HEIGHT_PX"
  (resize)="onResize()"
  headerHeight="1"
  bufferMultiplier="1"
  class="scroll-style wtf-scanner-virtual-scroll scanner-symbols-list-virtual-scroll"
  appResizeDirective
>
  <table
    [dataSource]="dataSource"
    [matSortActive]="sortState.column"
    [matSortDirection]="sortState.direction"
    [matSortStart]="defaultSortState.direction"
    [hidden]="!dataSource?.data?.length"
    [trackBy]="trackByFn"
    (matSortChange)="onSortChange($event)"
    mat-table
    matSort
    class="wheel-conservative-aggressive-table wtf-scanner-table scanner-symbol-table"
  >
    <ng-container matColumnDef="flag">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
        disableClear
      >
        Flag
      </th>
      <td
        *matCellDef="let element; let i = index"
        mat-cell
      >
        <div class="borderSelection">
          <app-symbol-flag
            [flag]="element.flag"
            [securityId]="element.security_id"
            [smileyListType]="smileyListType"
            [showNoneFlagOnlyOnHover]="true"
            [sendUpdateSignalOnChange]="false"
            [showStatisticsWhenVisible]="true"
            [rootClass]="'scanner-flag'"
            (menuOpened)="isSmileyMenuOpened = true"
            (flagChanged)="onSelectSmiley(element.security_id, $event)"
            (menuClosed)="isSmileyMenuOpened = false; onSmileyMenuClosed()"
            (click)="$event.stopPropagation()"
          ></app-symbol-flag>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="symbol">
      <th
        *matHeaderCellDef
        mat-sort-header
        disableClear
      >
        Symbol
      </th>
      <td
        (click)="onSelectSymbol(element)"
        *matCellDef="let element"
        mat-cell
      >
        <div class="borderSelection">
          {{ element.symbol | symbolCase }}
        </div>
      </td>
    </ng-container>

    <!--  TODO: remove this, use custom columns or the "app-scanner-symbols-list-v2" with custom columns  -->
    <ng-container matColumnDef="company">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
        disableClear
      >
        Company
      </th>
      <td
        (click)="onSelectSymbol(element)"
        *matCellDef="let element"
        mat-cell
      >
        <div class="relative borderSelection company-cell-content with-flags-statistic">
          <div class="company-title company-eclips">
            {{ element.company }}
          </div>

          @if (showSmileyStatistic) {
            <div class="flag-statistics-widget">
              <app-symbol-flag-statistic-widget
                [securityId]="element.security_id"
                [listType]="smileyListType"
              ></app-symbol-flag-statistic-widget>
            </div>
          }

          <div
            [class.hidden]="hideRemoveButton"
            class="ie-btns remove-btn"
          >
            <img
              [matTooltip]="'Delete symbol from the list'"
              [matTooltipPosition]="'above'"
              (click)="$event.preventDefault(); $event.stopPropagation(); onRemove(element)"
              src="assets/img/close-red.svg"
            />
          </div>
        </div>
      </td>
    </ng-container>

    <!--  map other columns - additional to default columns  -->
    @for (column of additionalDisplayedColumns; track column) {
      <ng-container [matColumnDef]="column">
        <th
          [ngClass]="column"
          *matHeaderCellDef
          mat-sort-header
          disableClear
        >
          {{ sortHeaderTitles[column] }}
        </th>
        <td
          [ngClass]="column"
          (click)="onSelectSymbol(element)"
          *matCellDef="let element"
          mat-cell
        >
          <div class="cell-content borderSelection">
            {{ element[column] }}
          </div>
        </td>
      </ng-container>
    }

    <tr
      *matHeaderRowDef="allDisplayedColumns; sticky: true"
      mat-header-row
      class="tableHeaderRow table-header-row hidden"
    ></tr>
    <tr
      [id]="'scanner-tr-' + row.security_id"
      [ngClass]="{ selected: row.id === selectedRow?.id }"
      (click)="selectedRow = row"
      *matRowDef="let row; columns: allDisplayedColumns"
      mat-row
    ></tr>
  </table>
</cdk-virtual-scroll-viewport>
